import { render, staticRenderFns } from "./HairTypesRegistryList.vue?vue&type=template&id=4e1b607e"
import script from "./HairTypesRegistryList.vue?vue&type=script&lang=js"
export * from "./HairTypesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports